import { get } from '../helpers/api';

export const BACKEND_SERVICE_URI = '/portal';
export const ACCOUNTS_BASE_URI = '/api/v1/user-cards';

export const getUserCardsDetails = async () =>
  get(`${BACKEND_SERVICE_URI}${ACCOUNTS_BASE_URI}/details`);
